import { API_URL } from '../config/connect';

const buildQuery = (params = {}) => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page);
    if (params.limit) q.append('limit', params.limit);
    if (params.country_id) q.append('country_id', params.country_id);
    if (params.region_id) q.append('region_id', params.region_id);
    if (params.district_id) q.append('district_id', params.district_id);
    if (params.category_id) q.append('category_id', params.category_id);
    if (params.subcategory_id) q.append('subcategory_id', params.subcategory_id);
    if (params.min_price) q.append('min_price', params.min_price);
    if (params.max_price) q.append('max_price', params.max_price);
    if (params.negotiable !== undefined) q.append('negotiable', params.negotiable);
    if (params.sort_by_date) q.append('sort_by_date', params.sort_by_date);
    if (params.sort_by_price) q.append('sort_by_price', params.sort_by_price);
    if (params.is_dealer) q.append('is_dealer', 'true');
    return q;
};

const getHeaders = () => {
    const headers = { 'Accept': 'application/json' };
    const token = localStorage.getItem('access_token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

export const getFeaturedAdverts = async (params = {}) => {
    try {
        const q = buildQuery(params);
        const response = await fetch(`${API_URL}/api/v1/announcements?${q.toString()}`, {
            method: 'GET',
            headers: getHeaders(),
        });
        if (!response.ok) throw new Error(`Error: ${response.status} - ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching featured adverts:', error);
        throw error;
    }
};

export const getRegularAdverts = async (params = {}) => {
    try {
        const q = buildQuery(params);
        const response = await fetch(`${API_URL}/api/v1/announcements?${q.toString()}`, {
            method: 'GET',
            headers: getHeaders(),
        });
        if (!response.ok) throw new Error(`Error: ${response.status} - ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching adverts:', error);
        throw error;
    }
};
